import React,{Component} from 'react';
import './Page2.css';
import { withRouter } from 'react-router-dom';
import { FiSearch,FiPaperclip, FiArrowUpLeft } from 'react-icons/fi';



import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,useLocation,Redirect
  } from "react-router-dom";



class Innerpage extends Component{
    constructor(props){
        super(props);
        this.state={
            clicked:[],
            activateFilter: "All",
            ShowSearchPage:false
        }
    }
  

   ToggleFilter=(name)=>{
       this.setState({activateFilter:name});
   }
   
 render(){
   
        var bor;
        return(
            
            <div className="headCon">
            <div className="SearchBaar">
                <div className="InnerSearch">
                    <Link to="/search">
                <FiArrowUpLeft className="inline_items Logo Previous" /></Link>

                   <input  className="TextBox inline_items SearchBox" placeholder="Search" />
                  
                </div>
            </div>
            
         <div className="Filters">
         <div className = "Cate" >
             
            
             <Router>
             
             <Link to="/searchpage" name = "All" onClick={(e)=>this.ToggleFilter("All")} className={`${this.state.activateFilter==="All"? "Active": ""} FilterElements`}  >
             All</Link>       
         <Link to="/searchpage/Brands" name = "Brands" onClick={(e)=>this.ToggleFilter("Brands")} className={`${this.state.activateFilter==="Brands"? "Active": ""} FilterElements`} >
             Brands</Link>
    <Link to="/searchpage/Sellers"  name = "Sellers" onClick={(e)=>this.ToggleFilter("Sellers")} className={`${this.state.activateFilter==="Sellers"? "Active": ""} FilterElements`}  >Top Sellers</Link>
        <Link to="/searchpage/Women"  onClick={(e)=>this.ToggleFilter("Women")} className={`${this.state.activateFilter==="Women"? "Active": ""} FilterElements`} >women</Link>
        <Link to="/searchpage/Men"  onClick={(e)=>this.ToggleFilter("Men")} className={`${this.state.activateFilter==="Men"? "Active": ""} FilterElements`} >Men</Link>
</Router>

<hr className=  { `${
    this.state.activateFilter==="Brands"? "ActivateBrand":
       this.state.activateFilter==="Sellers"? "ActivateSeller": 
             this.state.activateFilter==="Women" ? "ActivateWomen":
                 this.state.activateFilter==="Men"? "ActivateMen":
                 ""
} hr`
}
/>

    
             </div> 
             </div>  
         
         </div>
        
        );
    }
}

export default withRouter(Innerpage);